export const PRAMETER_VALUES = {
  PATIENT_ID: "patientId",
  TWIN_ID: "twinId",
  PLAN_ID: "planId",
  COMPARE_ID: "compareId",
  MODE: "mode",
};

export const ROUTES = {
  // USER_MANAGEMENT: "/user-management",
  SETTINGS: "/settings",
  SUPPORT: "/support",
  UI_PLAYGROUND: "/ui-playground",
  HOME: "/",
  PATIENTS: "/patients",
  PATIENT_DASHBOARD: `/patients/:${PRAMETER_VALUES.PATIENT_ID}`,
  DIGITAL_TWIN_SELECTION: `/patients/:${PRAMETER_VALUES.PATIENT_ID}/digital-twin/selection`,
  DIGITAL_TWIN_CREATION: `/patients/:${PRAMETER_VALUES.PATIENT_ID}/digital-twin/creation`,
  DIGITAL_TWIN_SELECTED: `/patients/:${PRAMETER_VALUES.PATIENT_ID}/digital-twin/:${PRAMETER_VALUES.TWIN_ID}`,
  DIGITAL_TWIN_COMPARISON: `/patients/:${PRAMETER_VALUES.PATIENT_ID}/digital-twin/:${PRAMETER_VALUES.TWIN_ID}/:${PRAMETER_VALUES.COMPARE_ID}`,
  DIGITAL_TWIN_EDIT: `/patients/:${PRAMETER_VALUES.PATIENT_ID}/digital-twin/:${PRAMETER_VALUES.TWIN_ID}/edit`,
  VALIDATION: `/validation/:${PRAMETER_VALUES.PATIENT_ID}/:${PRAMETER_VALUES.TWIN_ID}`,
  VALIDATION_WITH_MODE: `/validation/:${PRAMETER_VALUES.PATIENT_ID}/:${PRAMETER_VALUES.TWIN_ID}/:${PRAMETER_VALUES.MODE}`,
  CHECK: `/check/:${PRAMETER_VALUES.PATIENT_ID}/:${PRAMETER_VALUES.TWIN_ID}`,
  ALIGN: `/align/:${PRAMETER_VALUES.PATIENT_ID}/:${PRAMETER_VALUES.TWIN_ID}/:${PRAMETER_VALUES.PLAN_ID}`,
  ALIGN_COMPARISON: `/align/:${PRAMETER_VALUES.PATIENT_ID}/:${PRAMETER_VALUES.TWIN_ID}/:${PRAMETER_VALUES.PLAN_ID}/:${PRAMETER_VALUES.COMPARE_ID}`,
  NO_PERMISSION: "/access-denied",
  ERROR: "/error",
  NOT_FOUND: "*",
};

export const ROUTE_TYPES = {
  SUPPORT: "SUPPORT",
  SETTINGS: "SETTINGS",
  UI_PLAYGROUND: "UI_PLAYGROUND",
  HOME: "HOME",
  PATIENTS: "PATIENTS",
  PATIENT_DASHBOARD: "PATIENT_DASHBOARD",
  DIGITAL_TWIN: "DIGITAL_TWIN",
  VALIDATION: "VALIDATION",
  CHECK: "CHECK",
  ALIGN: "ALIGN",
  // USER_MANAGEMENT: "USER_MANAGEMENT",
  USER_VALIDATION: "USER_VALIDATION",
  NO_PERMISSION: "NO_PERMISSION",
  ERROR: "ERROR",
  NOT_FOUND: "NOT_FOUND",
};

const ROUTE_MATCHERS = {
  [ROUTE_TYPES.NOT_FOUND]: {
    pattern: /^\/not-found$/,
    extractParams: () => ({}),
  },
  [ROUTE_TYPES.SUPPORT]: {
    pattern: /^\/support$/,
    extractParams: () => ({}),
  },
  [ROUTE_TYPES.SETTINGS]: {
    pattern: /^\/settings$/,
    extractParams: () => ({}),
  },
  [ROUTE_TYPES.UI_PLAYGROUND]: {
    pattern: /^\/ui-playground$/,
    extractParams: () => ({}),
  },
  [ROUTE_TYPES.HOME]: {
    pattern: /^\/$/,
    extractParams: () => ({}),
  },
  [ROUTE_TYPES.PATIENTS]: {
    pattern: /^\/patients$/,
    extractParams: () => ({}),
  },
  // [ROUTE_TYPES.USER_MANAGEMENT]: {
  //   pattern: /^\/user-management$/,
  //   extractParams: () => ({}),
  // },
  [ROUTE_TYPES.USER_VALIDATION]: {
    pattern: /^\/user\/validate$/,
    extractParams: () => ({}),
  },
  [ROUTE_TYPES.NO_PERMISSION]: {
    pattern: /^\/access-denied$/,
    extractParams: () => ({}),
  },
  [ROUTE_TYPES.ERROR]: {
    pattern: /^\/error$/,
    extractParams: () => ({}),
  },
  [ROUTE_TYPES.PATIENT_DASHBOARD]: {
    pattern: /^\/patients\/([^/]+)$/,
    extractParams: match => ({
      patientId: match[1],
    }),
  },
  [ROUTE_TYPES.DIGITAL_TWIN]: {
    pattern: /^\/patients\/([^/]+)\/digital-twin(?:\/(.+))?$/,
    extractParams: match => ({
      patientId: match[1],
      // We'll let useParams handle the rest
    }),
  },
  [ROUTE_TYPES.VALIDATION]: {
    pattern: /^\/validation\/([^/]+)\/([^/]+)(?:\/([^/]+))?$/,
    extractParams: match => ({
      patientId: match[1],
      twinId: match[2],
      mode: match[3], // Optional mode parameter
    }),
  },
  [ROUTE_TYPES.CHECK]: {
    pattern: /^\/check\/([^/]+)\/([^/]+)$/,
    extractParams: match => ({
      patientId: match[1],
      twinId: match[2],
    }),
  },
  [ROUTE_TYPES.ALIGN]: {
    pattern: /^\/align\/([^/]+)\/([^/]+)\/([^/]+)(?:\/([^/]+))?$/,
    extractParams: match => ({
      patientId: match[1],
      twinId: match[2],
      planId: match[3],
      compareId: match[4], // Optional - present in comparison mode
    }),
  },
};

const buildRoute = (routeTemplate, params = {}) => {
  let route = routeTemplate;

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      route = route.replace(`:${key}`, value);
    }
  });

  return route;
};

export const RouteBuilders = {
  patientDashboard: patientId =>
    buildRoute(ROUTES.PATIENT_DASHBOARD, { patientId }),

  digitalTwinSelection: patientId =>
    buildRoute(ROUTES.DIGITAL_TWIN_SELECTION, { patientId }),

  digitalTwinCreation: patientId =>
    buildRoute(ROUTES.DIGITAL_TWIN_CREATION, { patientId }),

  digitalTwinSelected: (patientId, twinId, compareId = null) => {
    if (compareId) {
      return buildRoute(ROUTES.DIGITAL_TWIN_COMPARISON, {
        patientId,
        twinId,
        compareId,
      });
    } else {
      return buildRoute(ROUTES.DIGITAL_TWIN_SELECTED, { patientId, twinId });
    }
  },

  digitalTwinComparison: (patientId, twinId, compareId) =>
    buildRoute(ROUTES.DIGITAL_TWIN_COMPARISON, {
      patientId,
      twinId,
      compareId,
    }),

  digitalTwinEdit: (patientId, twinId) =>
    buildRoute(ROUTES.DIGITAL_TWIN_EDIT, { patientId, twinId }),

  validation: (patientId, twinId, mode = null) => {
    if (mode) {
      return buildRoute(ROUTES.VALIDATION_WITH_MODE, { patientId, twinId, mode });
    }
    return buildRoute(ROUTES.VALIDATION, { patientId, twinId });
  },

  check: (patientId, twinId) => buildRoute(ROUTES.CHECK, { patientId, twinId }),

  align: (patientId, twinId, planId) =>
    buildRoute(ROUTES.ALIGN, { patientId, twinId, planId }),

  alignComparison: (patientId, twinId, planId, comparePlanId) =>
    buildRoute(ROUTES.ALIGN_COMPARISON, {
      patientId,
      twinId,
      planId,
      compareId: comparePlanId,
    }),

  uiPlayground: () => ROUTES.UI_PLAYGROUND,
};

export const parseRoute = pathname => {
  for (const [routeType, matcher] of Object.entries(ROUTE_MATCHERS)) {
    const match = pathname.match(matcher.pattern);
    if (match) {
      return {
        routeType,
      };
    }
  }

  return {
    routeType: ROUTE_TYPES.NOT_FOUND,
  };
};

export const buildRouteFromKey = (routeKey, params = {}) => {
  const routeTemplate = ROUTES[routeKey];
  if (!routeTemplate) {
    throw new Error(`Route key "${routeKey}" not found in ROUTES`);
  }
  return buildRoute(routeTemplate, params);
};

export const validateRouteParams = (routeTemplate, params = {}) => {
  const requiredParams = (routeTemplate.match(/:([^/]+)/g) || []).map(param =>
    param.substring(1)
  );

  return requiredParams.every(
    param => params[param] !== undefined && params[param] !== null
  );
};
